import type { Resource } from '../../';
export const content_video_play: Resource = {"default":"Play Video"};
